import { pipe, Array as A } from 'effect';

import type { BankFeedAccountType, BankFeedSummary } from '@/domain/bankFeed/schemas';

// Currency-filter options derive from the per-account `currencies` lists of the active tab
// (DA-19365), not the tab-level `currencies` array. Empty `accountIds` spans every account of the
// tab; a non-empty selection narrows to the chosen accounts. De-duplicated preserving
// first-appearance order — the order the "snap to first valid" invariant (BankFeedRoute) relies on
// when the selected currency leaves the list.
export const deriveCurrencyOptions = (
  summary: BankFeedSummary | null,
  accountType: BankFeedAccountType,
  accountIds: string[],
): string[] =>
  pipe(
    summary?.items.find((item) => item.accountType === accountType)?.accounts ?? [],
    A.filter((account) => accountIds.length === 0 || accountIds.includes(account.id)),
    A.flatMap((account) => account.currencies),
    A.dedupe,
  );
